import { RouteRecordRaw } from 'vue-router';

const candidatesOverview = () => import('@/modules/candidates/pages/CandidatesOverview.vue');
const candidateDetails = () => import('@/modules/candidates/components/candidate-details/CandidateDetails.vue');

const CANDIDATE_ROUTES: Array<RouteRecordRaw> = [
   {
      path: '',
      name: 'CandidatesOverview',
      component: candidatesOverview,

      children: [
         {
            path: ':id',
            name: 'CandidateDetail',
            component: candidateDetails,
         },
      ],
   },
];

export { CANDIDATE_ROUTES };
